import { render, staticRenderFns } from "./IndicatorMatchMaking.vue?vue&type=template&id=4794b818&scoped=true&"
import script from "./IndicatorMatchMaking.vue?vue&type=script&lang=js&"
export * from "./IndicatorMatchMaking.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorMatchMaking.vue?vue&type=style&index=0&id=4794b818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4794b818",
  null
  
)

export default component.exports